import { Backdrop, CircularProgress, CircularProgressProps } from '@mui/material';

type FullScreenLoaderProps = {
  open?: boolean;
  color?: CircularProgressProps['color'];
};

const FullScreenLoader = ({ open = true, color = 'info' }: FullScreenLoaderProps) => {
  return (
    <Backdrop open={open} sx={{ zIndex: 1300 }}>
      <CircularProgress color={color} />
    </Backdrop>
  );
};

export default FullScreenLoader;
